import React from "react";

export const OPERATOR_PLAN_HELP_TITLE = "Operadores gratuitos do plano";

export function OperatorPlanHelpContent({ planStatus }) {
  const limit = planStatus ? planStatus.limit : 0;

  return (
    <>
      <p>
        <strong>Para que serve?</strong> Cada plano de acesso à plataforma inclui
        um número fixo de <strong>operadores gratuitos</strong>. Operadores além
        desse limite podem ser contratados com valor adicional por operador.
      </p>

      <p>
        <strong>Vagas do plano</strong> — o indicador mostra quantas vagas
        gratuitas estão em uso (ex.: <strong>3 de {limit || "X"}</strong>).
        Operadores marcados como <strong>do plano</strong> usam essas vagas.
      </p>

      <p>
        <strong>Operadores adicionais</strong> — cadastros que excedem o limite
        do plano continuam funcionando na plataforma, mas entram como{" "}
        <strong>adicionais</strong> (cobrança extra conforme contrato).
      </p>

      <p>
        <strong>Vínculo com o plano de acesso</strong> — sempre que o plano da
        fazenda for alterado (mais ou menos operadores inclusos), o limite aqui
        acompanha automaticamente. A contagem regressiva de acesso no topo da
        tela refere-se ao plano geral; este campo refere-se só às vagas de
        operadores.
      </p>

      <p>
        <strong>Reduzir vagas gratuitas</strong> — se o novo plano tiver menos
        operadores inclusos do que você já vinculou, use{" "}
        <strong>Escolher operadores do plano</strong> para definir quais
        permanecem nas vagas gratuitas. Os demais passam a ser adicionais.
      </p>

      <p>
        <strong>Exemplo</strong>
      </p>
      <ul>
        <li>
          Plano com <strong>5 operadores gratuitos</strong> — você cadastra Ana,
          Bruno, Carlos, Diana e Eduardo como operadores do plano.
        </li>
        <li>
          Cadastra <strong>Felipe</strong> sem vaga disponível → entra como{" "}
          <strong>operador adicional</strong>.
        </li>
        <li>
          Troca para plano com <strong>3 operadores</strong> → escolhe Ana,
          Bruno e Carlos para manter nas vagas; Diana, Eduardo e Felipe ficam
          adicionais até você ajustar ou ampliar o plano.
        </li>
      </ul>
    </>
  );
}
